import React from 'react'
import { connect } from 'react-redux'
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch'
import { Box } from '@mui/material'
import { THEME_COLORS } from '@/theme/skinSx'
import {
  pageTitleRootSx,
  pageTitleFirstSx,
  pageTitleHeadingSx,
  pageTitleIconboxSx,
  pageTitleLogoWrapSx,
  pageTitleLogoSx,
  pageTitleDescriptionSx,
  pageTitleDefaultIconSx,
} from '@/layout-blueprints/chromeComponentSx'

const PageTitle = (props) => {
  const {
    pageTitleShadow,
    pageTitleIconBox,
    pageTitleDescription,
    titleHeading,
    titleDescription,
    icon,
    logoSrc,
    logoAlt,
    style,
    children,
  } = props

  const hasHeading = Boolean(titleHeading)
  const hasDescription = Boolean(
    titleDescription && pageTitleDescription,
  )
  const hasText = hasHeading || hasDescription

  return (
    <>
      <Box
        sx={{
          ...pageTitleRootSx({ shadow: pageTitleShadow  }),
          marginBottom: '20px',
          ...style,
        }}
      >
        <Box>
          <Box sx={pageTitleFirstSx}>
            {logoSrc ? (
              <Box sx={pageTitleLogoWrapSx}>
                <Box
                  component="img"
                  src={logoSrc}
                  alt={logoAlt || ''}
                  sx={pageTitleLogoSx}
                />
              </Box>
            ) : (
              pageTitleIconBox && (
                <Box sx={[pageTitleIconboxSx, {
                  height: "70px !important",
                  width: "70px !important",
                  lineHeight: "70px !important",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  p: 0,
                }]}>
                  <Box
                    sx={{
                      height: "70px !important",
                      width: "70px !important",
                      lineHeight: "70px !important",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 0,
                      color: "#368cff",
                      "& svg": { color: "inherit", fill: "currentColor", overflow: "visible" },
                    }}
                  >
                    {icon ? (
                      icon
                    ) : (
                      <RocketLaunchIcon sx={pageTitleDefaultIconSx} />
                    )}
                  </Box>
                </Box>
              )
            )}
            {hasText && (
              <Box sx={pageTitleHeadingSx}>
                {hasHeading && <h1>{titleHeading}</h1>}
                {hasDescription && (
                  <Box sx={pageTitleDescriptionSx}>
                    {titleDescription}
                  </Box>
                )}
              </Box>
            )}
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flex: '0 0 auto',
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  )
}

const mapStateToProps = (state) => ({
  pageTitleStyle: state.DeprecatedThemeOptions.pageTitleStyle,
  pageTitleBackground:
    state.DeprecatedThemeOptions.pageTitleBackground,
  pageTitleShadow: state.DeprecatedThemeOptions.pageTitleShadow,
  pageTitleIconBox: state.DeprecatedThemeOptions.pageTitleIconBox,
  pageTitleDescription:
    state.DeprecatedThemeOptions.pageTitleDescription,
})

export default connect(mapStateToProps)(PageTitle)
